// Shared process step constants
export const STEP_SELECT_SCOPE = 'select-scope';
export const STEP_SELECT_TYPE = 'select-type';
export const STEP_SUCCESS = 'success';
export const STEP_INFO = 'info';
export const STEP_CONFIRM = 'confirm';

// Base step type that can be extended by specific processes
// Process-specific step combinations
